module.exports = __webpack_public_path__ + "img/symbol_10.54538869.png";